/**
 * Whether the current browser supports the Contact Picker API.
 *
 * The Contact Picker API (https://developer.mozilla.org/docs/Web/API/Contact_Picker_API)
 * is only available on Chromium-based browsers on Android. Used for progressive
 * enhancement — when unsupported, users type contact details manually.
 */
export function isContactPickerSupported(): boolean {
  return typeof navigator !== 'undefined' && 'contacts' in navigator && 'ContactsManager' in window;
}
